import { render, staticRenderFns } from "./locais.vue?vue&type=template&id=a67ce252"
import script from "./locais.vue?vue&type=script&lang=js"
export * from "./locais.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports